export default {
  theme: {
    accentColor: '#FE5000',
    hoverColor: 'rgba(254,80,0,0.13)',
    backgroundColor: 'rgba(251,249,248,100)',
    userMessageBubbleColor: '#FE5000',
    userMessageFontColor: '#FFFFFF',

    botMessageBubbleColor: '#f2f2f2',
    botMessageFontColor: 'rgba(0,0,0,0.54)',

    botCardMessageBackgroundColor: 'rgba(242,242,242,1)',
    botCardMessageTextColor: 'rgba(0,0,0,0.54)',
    botCardButtonOutlineColor: 'rgba(254,80,0,1)',
    botCardButtonBackgroundColor: 'rgba(255,255,255,1)',
    botCardButtonTextColor: 'rgba(0,0,0,1)',

    botCardButtonBackgroundColorSecondary: 'rgba(255,255,255,1)',
    hoverColorSecondary: 'rgba(254,80,0,0.13)',
    botCardButtonTextColorSecondary: 'rgba(0,0,0,1)',

    introBackgroundColor: 'rgba(161, 161, 161, 100)',
    introTitleColor: 'rgba(71, 71, 71, 1)',
    introSubtitleColor: 'rgba(71, 71, 71, 1)',
    introPrimaryButtonColor: 'rgba(93, 93, 93, 1)',
    introPrimaryButtonTextColor: 'rgba(250, 250, 253, 1)',
    introSecondaryButtonColor: 'rgba(182, 182, 182, 1)',
    introSecondaryButtonTextColor: 'rgba(71, 71, 71, 1)',
    introCardTextColor: 'rgba(255, 255, 255, 1)'
  },

  strings: {
    header: 'Need help? Ask our bot!',
    chatPlaceholder: 'Write a reply...',
    introTitle: 'Welcome!',
    introSubtitle: 'How can I help you today?',
    introShortcutCommand: '',
    introShortcutName: '',
    introCardTitle: 'Chat with our assistant',
    introCardInfo: 'Our virtual assistant is here to help you with any questions you might have.',
    introCardLink: ''
  },

  images: {
    header: 'https://infdev.ambithub.com/webchat-testing/bitChatHeader.svg',
    chatAvatar: 'https://infdev.ambithub.com/webchat-testing/bitAvatar.svg',
    introBackground: '',
    introCardBackground: ''
  },

  dimensions: {
    panelWidth: '410px',
    panelHeight: '650px',
    panelPosition: 'right: 0; bottom: 0px'
  },

  showLauncher: true,

  enableAutoOpenOnMobile: true,

  enableAutoOpen: true,

  rememberConversation: true,

  usePolling: false
};



// WEBPACK FOOTER //
// ./src/initialiser/configDefaults.js